import { render, staticRenderFns } from "./TicketRequestRefund.vue?vue&type=template&id=0bead53c&scoped=true&"
import script from "./TicketRequestRefund.vue?vue&type=script&lang=js&"
export * from "./TicketRequestRefund.vue?vue&type=script&lang=js&"
import style0 from "./TicketRequestRefund.vue?vue&type=style&index=0&id=0bead53c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bead53c",
  null
  
)

export default component.exports